import { Formik, Form } from 'formik'
import React from 'react'
import { useDispatch } from 'react-redux'
import * as Yup from 'yup'
import styled from 'styled-components'
import { _, withCapture, validation } from 'utils'
import Button from 'components/Button'
import SubmitButton from 'features/forms/components/SubmitButton'
import SelectField, { convertGroupedTags } from 'features/forms/components/SelectField'
import { MovieTagsQuery, MovieTagsQueryVariables } from 'generated/graphql'
import useQuery from 'hooks/useQuery'
import { useEventSlug } from 'hooks'
import TextField from '../../forms/components/TextField'
import { showNotification } from '../../notifications'
import { showErrorNotification } from '../../notifications/notificationsSlice'
import Switch from '../../forms/components/Switch'
import FileUpload, { IMAGE_ONLY } from '../../forms/components/FileUpload'
import { createMovie } from '../graphql/mutation'
import { tagsQuery } from '../graphql/query'

const S = {
    Switch: styled(Switch)`
        margin-top: 5px;
        margin-bottom: 40px !important;
    `,
    Actions: styled.div`
        display: flex;
        justify-content: flex-end;
        width: 100%;
        padding-right: 10px;
    `
}

interface Props {
    close?: () => void
    callGetMovies?: () => void
    maxOrder?: number,
    cinemaId: number
}

const initialValues = {
    title: '',
    subtitle: '',
    embeddedUrl: '',
}

export const MovieValidation = Yup.object().shape({
    title: Yup.string().required().min(3),
    subtitle: Yup.string().required().min(3),
    embeddedUrl: validation.url.required(),
})

export const FormContent = ({ close }: { close?: () => void }) => {
    const eventSlug = useEventSlug()
    const { data: tagsData } = useQuery<MovieTagsQuery, MovieTagsQueryVariables>(tagsQuery, {
        eventId: eventSlug,
    })
    return (
        <Form className="row">
            <TextField
                name="title"
                label={_('movie.form.title')}
                isRequired
            />
            <TextField
                name="subtitle"
                label={_('movie.form.subtitle')}
                isRequired
            />
            <TextField
                name="embeddedUrl"
                label={_('movie.form.embedded_url')}
                isRequired
            />
            <FileUpload
                name="imageThumbnail"
                label={_('movie.form.image_thumbnail')}
                accept={IMAGE_ONLY}
                placeholder={_('movies.form.image_thumbnail_placeholder')}
                hideLibrary
            />
            <SelectField
                name="tags"
                label={_('show.form.tags')}
                isMulti
                options={convertGroupedTags(tagsData?.event?.movieTags)}
                optionLabel="text"
                optionValue="id"
            />
            <S.Actions>
                <Button onClick={close} variant="secondary" style={{ marginRight: 10 }}>
                    {_('button.cancel')}
                </Button>
                <SubmitButton />
            </S.Actions>
        </Form>
    )
}

const CreateMovie = ({
    close, callGetMovies, maxOrder, cinemaId
}: Props) => {
    const dispatch = useDispatch()

    const onSubmit = withCapture(async (values) => {
        const response = await createMovie({ ...values, order: maxOrder+1000, cinemaId })
        if (response.data) {
            dispatch(showNotification({
                type: 'success',
                body: _('form.notification.create_success'),
            }))
            callGetMovies()
            close()
        } else {
            dispatch(showErrorNotification(response.errors))
        }
    })

    return (
        <Formik
            initialValues={initialValues}
            validationSchema={MovieValidation}
            onSubmit={onSubmit}
        >
            <FormContent close={close} />
        </Formik>
    )
}

export default CreateMovie
